import defaultTheme, { Gray, Green } from "./default-theme";

// 主题色
const Theme = {
  "theme-4": Green["green-1"],
  "theme-5": Green["green-2"],
  "theme-6": Green["green-3"],
};

// 字体色
const ColorText = {
  "color-text-1": Gray["gray-7"],
  "color-text-2": Gray["gray-8"],
  "color-text-3": Gray["gray-9"],
  "color-text-4": Gray["gray-14"],
  "color-text-5": Gray["gray-4"],
};

// 填充色
const ColorFill = {
  "color-fill-1": Gray["gray-1"],
  "color-fill-2": Gray["gray-2"],
  "color-fill-3": Gray["gray-3"],
  "color-fill-4": Gray["gray-4"],
  "color-fill-5": Gray["gray-5"],
  "color-fill-6": Gray["gray-6"],
  "color-fill-7": Gray["gray-13"],
  "color-fill-8": Gray["gray-14"],
};

// 描边色
const ColorLine = {
  "color-line-1": Gray["gray-5"],
  "color-line-2": Gray["gray-6"],
  "color-line-3": Theme["theme-5"],
};

// 主题按钮状态色
const ThemeBtnStatus = {
  "theme-btn-nor": Theme["theme-5"],
  "theme-btn-click": Theme["theme-4"],
  "theme-btn-hover": Theme["theme-6"],
};

// 普通按钮状态色
const CommonBtnStatus = {
  "common-btn-nor": Gray["gray-12"],
  "common-btn-click": Gray["gray-10"],
  "common-btn-hover": Gray["gray-10"],
  "common-btn-disable": Gray["gray-11"],
};

export default {
  ...defaultTheme,
  ...Theme,
  ...ColorText,
  ...ColorFill,
  ...ColorLine,
  ...ThemeBtnStatus,
  ...CommonBtnStatus,
};
